export default __webpack_public_path__ + "static/media/repayment-channel-icon1.be9b083d.png";